import { Modal } from "flowbite-react";
import { FaCheckCircle } from "react-icons/fa";
import { IIndicators } from "../../../types/Indicators.type";
import { useToastContext } from "../../../common/components/ui/toast/toast.context";

type Props = {
  data: IIndicators | undefined;
  open: boolean
  onClosed: () => void;
}

export default function LinkAmbassador(props: Props) {
  const handleCloseModal = () => { props.onClosed && props.onClosed() }
  const { notifySuccess } = useToastContext();

  const copyLink = (text: string) => {
    notifySuccess(`Link Copiado!`);
    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand('copy');
    document.body.removeChild(textarea);
  };

  return (
    <Modal
      className="relative"
      show={props.open}
      onClose={() => handleCloseModal()}
    >
      <Modal.Header className="text-black">
        <div className="flex flex-col sm:flex-row items-center sm:items-baseline justify-center bg-gray-100 p-4">
          <FaCheckCircle className="text-greenPrimary" />
          <h2 className="ml-0 mt-4 sm:ml-2 text-black text-center sm:text-left text-lg sm:text-xl">
            Atualização realizada com sucesso!
          </h2>
        </div>
      </Modal.Header>
      <Modal.Body className="dark:text-black">
        <div className="flex flex-col items-center justify-center bg-gray-100 px-4 py-2">
          <h3 className="text-base sm:text-lg font-semibold mb-4 text-center">
            Copie abaixo seu link para compartilhar com seus Leads:
          </h3>
        </div>
        <div className="flex flex-col sm:flex-row items-center justify-center bg-gray-100 p-4">
          <span className="text-md mb-4 sm:mb-0 break-all text-center sm:text-left">
            https://embaixador.locavibe.com.br/embaixador/{props.data?.code}
          </span>
          <button
            onClick={() =>
              copyLink(`https://embaixador.locavibe.com.br/embaixador/${props.data?.code}`)
            }
            className="bg-blue-500 hover:bg-blue-700 text-sm text-white font-bold py-2 px-4 rounded mt-4 sm:mt-0 sm:ml-4"
          >
            Copiar
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
}